// Capability (Saturn): the constellation surrounding Saturn scores more.
import { ALIGNMENT_NUMBERS as N } from '../constants';
import { ownIndex } from '../shared/own';
import type { AlignmentDef } from '../types';

export const capability: AlignmentDef = {
  id: 'capability',
  planet: 'saturn',
  name: 'Capability',
  text: () => `The constellation that surrounds Saturn scores +${N.capabilityPercent}%.`,
  wordPercent: (c, ctx) => (c.index === ownIndex(ctx, 'capability') ? N.capabilityPercent : 0),
};
